import { render, staticRenderFns } from "./ProductEditTabOffices.vue?vue&type=template&id=aad49b50&"
import script from "./ProductEditTabOffices.vue?vue&type=script&lang=js&"
export * from "./ProductEditTabOffices.vue?vue&type=script&lang=js&"
import style0 from "./ProductEditTabOffices.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports